import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, HostListener } from '@angular/core';
import { VideoObject } from '../../models/video-model';
import { DataService } from '../../services/data.service';
import { environment } from '../../../environments/environment';
import { animate, style, transition, trigger } from '@angular/animations';
import { TagObject } from '../../models/tag-model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-video-player',
    templateUrl: './video-player.component.html',
    styleUrls: ['./video-player.component.scss'],
    animations: [
        trigger('fader', [
            transition('void => work', [
                style({ opacity: 0 }),
                animate('0.5s', style({ opacity: '*' }))
            ]),
            transition('work => void', [
                animate('0.5s', style({ opacity: 0 }))
            ])
        ]),
        trigger('expander_horizontal', [
            transition('void => work', [
                style({ width: 0, height: '100%' }),
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ width: '100%' }))
            ]),
            transition('work => void', [
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ width: 0, height: '100%' }))
            ])
        ]),
        trigger('expander_vertical', [
            transition('void => work', [
                style({ width: '100%', height: 0 }),
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ height: '100%' }))
            ]),
            transition('work => void', [
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ height: 0, width: '100%' }))
            ])
        ]),
        trigger('from_right', [
            transition('void => work', [
                style({ transform: 'translateX(100%)' }),
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ transform: 'translateX(0)' }))
            ]),
            transition('work => void', [
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ transform: 'translateX(100%)' }))
            ])
        ]),
        trigger('from_left', [
            transition('void => work', [
                style({ transform: 'translateX(-100%)' }),
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ transform: 'translateX(0)' }))
            ]),
            transition('work => void', [
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ transform: 'translateX(-100%)' }))
            ])
        ]),
        trigger('from_top', [
            transition('void => work', [
                style({ transform: 'translateY(-100%)' }),
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ transform: 'translateY(0)' }))
            ]),
            transition('work => void', [
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ transform: 'translateY(-100%)' }))
            ])
        ]),
        trigger('from_bottom', [
            transition('void => work', [
                style({ transform: 'translateY(100%)' }),
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ transform: 'translateY(0)' }))
            ]),
            transition('work => void', [
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ transform: 'translateY(100%)' }))
            ])
        ]),
        trigger('rotation', [
            transition('void => work', [
                style({ transform: 'rotate(360deg)' }),
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ transform: 'rotate(0deg)' }))
            ]),
            transition('work => void', [
                animate('0.5s cubic-bezier(0.22, 1, 0.36, 1)', style({ transform: 'rotate(360deg)' }))
            ])
        ]),
    ]
})
export class VideoPlayerComponent implements OnInit {

    @HostListener('window:keydown.Space', ['$event'])
    listenSpace(e: KeyboardEvent): void {
        this.playPauseKeyboard()
    }

    public currentPlayCountdown = false;
    public playerPlayed = false;
    public loading = true;
    public canPlay = false;

    public currentTime = 0;
    public currentPlayerScale = 1;

    private $element: ElementRef<HTMLVideoElement>;

    @ViewChild('player')
    public set player(element: ElementRef<HTMLVideoElement>) {
        if (!this.$element) {
            this.$element = element;

            if (element && element.nativeElement) {


                this.makeAutoplayOfRealVideo();
            }
        }


    }

    public get player(): ElementRef<HTMLVideoElement> {
        return this.$element;
    }

    @Input() videoData: VideoObject;
    public videoContext: CanvasRenderingContext2D;

    public removingR = 255;
    public removingG = 255;
    public removingB = 255;

    public videoWidth = 1280;
    public videoHeight = 720;

    public playbackRate = 1;

    public isFullscreen = false;
    public moveInterval;
    public showPlayerControls = true;
    public duration = 0;
    public formattedDuration: string;
    public currentTimeS = 0;
    public isSelectVisible: boolean = false;
    public playedcountdown: boolean = false;

    @ViewChild('canvas') public canvasObject: ElementRef<HTMLCanvasElement>;

    public makeAutoplayOfRealVideo(): void {


        this.player.nativeElement.pause();

        this.player.nativeElement.removeAttribute('src');
        this.player.nativeElement.innerHTML = '';

        const source1 = document.createElement('source');
        source1.setAttribute('src', this.videoData.path + '.mp4');
        source1.setAttribute('type', 'video/mp4');

        this.player.nativeElement.appendChild(source1);

        this.player.nativeElement.addEventListener('loadedmetadata', () => {
            this.setDuration(this.player.nativeElement);

        });

       /*  this.player.nativeElement.addEventListener('loadedmetadata', () => {
            this.duration = this.player.nativeElement.duration;
        }); */

        this.player.nativeElement.addEventListener('timeupdate', () => {
            this.currentTimeS = this.player.nativeElement.currentTime;
        });

        this.player.nativeElement.addEventListener('canplay', () => {
            this.loading = false;
            this.canPlay = true;
        });
        
        this.player.nativeElement.addEventListener('playing', () => {
            this.loading = false;
        });
        
        this.player.nativeElement.addEventListener('canplaythrough', () => {
            this.loading = false;
        });
        
        this.player.nativeElement.addEventListener('loadstart', () => {
            this.loading = true;
        });
        
        this.player.nativeElement.addEventListener('waiting', () => {
            this.loading = true;
        });
        
       /*  this.player.nativeElement.addEventListener('stalled', () => {
            this.loading = true;
        }); */
        
        this.player.nativeElement.addEventListener('error', () => {
            this.loading = false;
        });
        
        


        /* Prioriza o webm caso exista */
        if (this.videoData.hasWebm) {

            const source2 = document.createElement('source');
            source2.setAttribute('src', this.videoData.path + '.webm');
            source2.setAttribute('type', 'video/webm');

            this.player.nativeElement.prepend(source2);

            // priorize webm on android (fix Xiaomi bug https://trello.com/c/gu7jIION/804)
            /* if (this.isAndroid()) {
                this.player.nativeElement.prepend(source2);
            }
            else {
                this.player.nativeElement.appendChild(source2);
            } */
        }
        this.player.nativeElement.load();

        /* if (this.isAndroid() || this.isIOSDevice()) {
            this.player.nativeElement.controls = this.data.controls;
        } */

        if (!this.data.controls) {
            const style = document.createElement('style');
            style.innerHTML = 'video::-webkit-media-controls { display:none !important; }';
            document.getElementsByTagName('head')[0].appendChild(style);
        }

        this.player.nativeElement.oncontextmenu = ev => {
            return false;
        };

        if (this.data.autoplay) {
            this.player.nativeElement.play().then(value => {
                // All good. Video is autoplayed

            }).catch(reason => {
                // Autoplay with sound not supported

                if (this.data.countdown && !this.playedcountdown) {

                    this.currentPlayCountdown = true;
                    // Show countdown
                    this.player.nativeElement.innerHTML = '';
                    this.player.nativeElement.src = this.getCountdownLink();
                    this.player.nativeElement.muted = true;
                    this.player.nativeElement.controls = false;
                    this.playedcountdown = true;
                    this.player.nativeElement.addEventListener('ended', ev => {
                        if (this.currentPlayCountdown) {
                            this.currentPlayCountdown = false;

                            this.makeAutoplayOfRealVideo();

                        }


                    });
                    this.player.nativeElement.play();


                } else {

                    this.currentPlayCountdown = false;
                    // Just play without sound
                    this.player.nativeElement.muted = true;
                    this.player.nativeElement.play();

                }
            }).finally(() => {

            });
        }
    }

    constructor(public data: DataService,
        private ref: ChangeDetectorRef,
        private snackbar: MatSnackBar) {

        document.onfullscreenchange = ev => {
            this.isFullscreen = document.fullscreenElement !== null;
        };

        window.onresize = ev => {
            this.ref.detectChanges();
        };

    }

    setDuration(videoElement: HTMLVideoElement) {
        let totalSeconds = this.player.nativeElement.duration;
        /* Load the video duration */
        if (isNaN(totalSeconds) || !isFinite(totalSeconds) || totalSeconds <= 0) {

            this.formattedDuration = '--:--';
        } else {
            this.setFormattedDuration(totalSeconds);
        }
    }
    
    setFormattedDuration(totalSeconds: number) {
        this.formattedDuration = this.formatDuration(totalSeconds);
    }
    
    formatDuration(duration: number): string {

        /* Format the duartion according hours or minutes */
        
        if (isNaN(duration) || duration < 0) {
            return '--:--';
        }
        const hours = Math.floor(duration / 3600);
        const minutes = Math.floor((duration % 3600) / 60);
        const seconds = Math.floor(duration % 60);
        let formattedTime: string;
        if (hours > 0) {
            formattedTime = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
        } else {
            formattedTime = `${this.pad(minutes)}:${this.pad(seconds)}`;
        }
        return formattedTime;
    }
    
    pad(num: number): string {
        return num.toString().padStart(2, '0');
    }
    
    
    private hexToR(h): number {
        return parseInt((this.cutHex(h)).substring(0, 2), 16);
    }

    private hexToG(h): number {
        return parseInt((this.cutHex(h)).substring(2, 4), 16);
    }

    private hexToB(h): number {
        return parseInt((this.cutHex(h)).substring(4, 6), 16);
    }

    private cutHex(h): string {
        return (h.charAt(0) === '#') ? h.substring(1, 7) : h;
    }
    
    ngOnInit(): void {
        this.removingR = this.hexToR(this.videoData.floatingColor);
        this.removingG = this.hexToG(this.videoData.floatingColor);
        this.removingB = this.hexToB(this.videoData.floatingColor);

        this.makeChroma();

    }

    ngAfterViewInit(): void {
        const gradientColor = this.videoData.secondaryColor || '#FFFFFF';
        const toolDivElement = document.querySelector('.toolBox') as HTMLElement;
        toolDivElement.style.setProperty('--gradient-color', gradientColor);
    }

    setPlaybackRate(rate: number) {
        this.playbackRate = rate;
        this.isSelectVisible = false;
    }

    hidePoster(): void {
        this.playerPlayed = true;
        // console.log('PLAYER PLAYED');
    }

    playVideo(event: MouseEvent): void {
        event.stopImmediatePropagation();

        this.player.nativeElement.play();

    }


    /* Responsible for unmute when there is an interaction with play button and the autoplay is true */
    unmuteAction() {
        if(this.data.autoplay){
            this.player.nativeElement.muted = false;
        }
    }

    onAnywhereClick($event: MouseEvent): void {

        if (this.isSelectVisible === true) {
            this.isSelectVisible = false;
            return;
        }

        if (this.isSafari()) {
            $event.preventDefault();
            $event.stopImmediatePropagation();

            if (this.player && this.player.nativeElement) {
                if (this.data.allowPause) {
                    this.player.nativeElement.muted = false;

                    if ($event.clientY < document.body.clientHeight - 50) {
                        if (this.player.nativeElement.paused) {
                            this.player.nativeElement.play();
                            console.log('PLAY IOS');
                        } else {
                            this.player.nativeElement.pause();
                            console.log('PAUSE IOS');
                        }
                    }

                }


            }

            return;
        }

        $event.preventDefault();
         if (this.player && this.player.nativeElement) {
             if (this.currentPlayCountdown) {
                 this.player.nativeElement.muted = false;
             } else {
                 if (this.data.allowPause) {
                     this.player.nativeElement.muted = false;
                     if (this.player.nativeElement.paused) {
                         this.player.nativeElement.play();
                     } else {
                         this.player.nativeElement.pause();
                     }
                 }
             }
         }
    }

    isIOSDevice(): boolean {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        // console.log(isIOS);
        return isIOS;
    }

    isSafari(): boolean {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    isAndroid(): boolean {
        return /(android)/i.test(navigator.userAgent);
    }

    fullscreenAllowed(): boolean {
        return document.fullscreenEnabled;
    }

    getCountdownLink(): string {
        return environment.mediaStorageUrl + 'video_manager/videos2/' + this.data.videoData.countdownTheme + '.mp4';
    }

    onPlayerClick($event: MouseEvent): void {
        if (this.player) {
            this.player.nativeElement.muted = false;
        }
        if (this.isSafari()) {
            $event.preventDefault();
        }
    }

    onTimeUpdate($event: Event): void {
        if (!this.currentPlayCountdown && this.player.nativeElement.duration) {
            const percent = this.player.nativeElement.currentTime / this.player.nativeElement.duration;

            this.currentTime = this.player.nativeElement.currentTime;

            this.data.sendViewData(percent);

            try {
                window.parent.postMessage({
                    currentTime: this.player.nativeElement.currentTime,
                    duration: this.player.nativeElement.duration
                }, '*');
            } catch (e) {
                console.log('Time message not sent');
                console.log(e);
            }

            // Working with snackbars
            this.videoData.getSnackbarTags().forEach(item => {
                let shouldBeVisible = false;

                if (item.startTime < this.currentTime) {
                    if (item.endTime === 0) {
                        shouldBeVisible = true;
                    } else {
                        if (item.endTime > this.currentTime) {
                            shouldBeVisible = true;
                        }
                    }
                }

                if (shouldBeVisible && !item.snackbarRef) {
                    let actionText = '';
                    if (item.type !== 'none') {
                        actionText = '>>';
                    }

                   

                    item.snackbarRef = this.snackbar.open(
                        item.viewContent,
                        actionText,
                        {
                            verticalPosition: item.y === 0 ? 'top' : 'bottom',
                            horizontalPosition: item.x === 0 ? 'left' : item.x === 1 ? 'center' : 'right',
                            panelClass: ['mat-elevation-z24']
                        });
                    item.snackbarRef.afterDismissed().subscribe(value => {
                        if (value.dismissedByAction) {
                            this.onTagClick(item);
                        }
                    });
                }

                if (!shouldBeVisible && item.snackbarRef) {
                    item.snackbarRef.dismiss();
                    item.snackbarRef = undefined;
                }

            });
        }

    }

    getPosterUrl(): string {
        return environment.serverUrl + this.data.videoData.poster;
    }

    getPausePosterUrl(): string {
        return environment.serverUrl + this.data.videoData.posterPause;
    }

    getEndPosterUrl(): string {
        return environment.serverUrl + this.data.videoData.posterEnd;
    }

    makeChroma(): void {
        setInterval(() => {
            if (!this.player.nativeElement.paused) {
                this.makeFrame();
            }
        }, 42);
    }

    makeFrame(): void {
        if (this.videoData.floatingEnabled && this.player && this.canvasObject) {

            if (this.player.nativeElement.videoHeight > 0 && this.player.nativeElement.videoWidth > 0) {
                const startTime = new Date().getTime();

                if (!this.videoContext) {
                    this.canvasObject.nativeElement.width = this.player.nativeElement.videoWidth;
                    this.canvasObject.nativeElement.height = this.player.nativeElement.videoHeight;


                    this.videoContext = this.canvasObject.nativeElement.getContext('2d');
                }

                const tempCanvas = document.createElement('canvas');
                tempCanvas.width = this.player.nativeElement.videoWidth;
                tempCanvas.height = this.player.nativeElement.videoHeight;
                const tempContext = tempCanvas.getContext('2d');

                tempContext.drawImage(this.player.nativeElement, 0, 0, this.player.nativeElement.videoWidth, this.player.nativeElement.videoHeight);

                const normalImageData = tempContext.getImageData(0, 0, this.player.nativeElement.videoWidth, this.player.nativeElement.videoHeight);
                const floatingImageData = tempContext.createImageData(this.player.nativeElement.videoWidth, this.player.nativeElement.videoHeight);

                for (let i = 0; i < normalImageData.width * normalImageData.height * 4; i += 4) {
                    const r = normalImageData.data[i + 0];
                    const g = normalImageData.data[i + 1];
                    const b = normalImageData.data[i + 2];
                    let a = normalImageData.data[i + 3];

                    if ((r <= this.removingR + this.videoData.floatingRange && r >= this.removingR - this.videoData.floatingRange) &&
                        (g <= this.removingG + this.videoData.floatingRange && g >= this.removingG - this.videoData.floatingRange) &&
                        (b <= this.removingB + this.videoData.floatingRange && b >= this.removingB - this.videoData.floatingRange)) {
                        a = 0;
                    }

                    if (a !== 0) {
                        floatingImageData.data[i + 0] = r;
                        floatingImageData.data[i + 1] = g;
                        floatingImageData.data[i + 2] = b;
                        floatingImageData.data[i + 3] = a;
                    }
                }

                this.videoContext.clearRect(0, 0, this.player.nativeElement.videoWidth, this.player.nativeElement.videoHeight);
                this.videoContext.putImageData(floatingImageData, 0, 0);

                // console.log(new Date().getTime() - startTime);

            }
        } else {
            this.videoContext = undefined;
        }

    }

    onVideoLoaded($event: Event): void {
        this.videoWidth = this.player.nativeElement.videoWidth;
        this.videoHeight = this.player.nativeElement.videoHeight;

        this.makeFrame();
    }

    getVideoOverlapStyles(): string {
        if (window.innerWidth / window.innerHeight > this.videoWidth / this.videoHeight) {
            this.currentPlayerScale = this.videoHeight / window.innerHeight;
        } else {
            this.currentPlayerScale = this.videoWidth / window.innerWidth;
        }

        const left = window.innerWidth / 2 - (this.videoWidth / this.currentPlayerScale) / 2;
        const top = window.innerHeight / 2 - (this.videoHeight / this.currentPlayerScale) / 2;

        return 'left: ' + left + 'px; top: ' + top + 'px; width: ' + this.videoWidth + 'px; height: ' + this.videoHeight + 'px; transform: scale(' + 1 / this.currentPlayerScale + '); transform-origin: top left;  ';
    }

    getTagStyles(tag: TagObject): string {
        /*
        if (1280 / 720 > this.videoWidth / this.videoHeight) {
            this.currentPlayerScale = this.videoHeight / 720;
        } else {
            this.currentPlayerScale = this.videoWidth / 1280;
        }*/

        return 'transform: translate3d(' + tag.x + 'px, ' + tag.y + 'px, 0) scale(' + tag.scale + '); transform-origin: top left;';
    }

    public isTagCurrentlyVisible(tag: TagObject): boolean {
        if (this.currentPlayCountdown) {
            return false;
        }

        if (this.currentTime >= tag.startTime) {
            if (+tag.endTime === 0) {
                return true;
            } else if (tag.endTime > this.currentTime) {
                return true;
            }
        }
        return false;
    }

    onTagClick(tag: TagObject): void {
        try {
            this.player.nativeElement.pause();

        } catch (e) {
            // Dont pause :)
        }


        switch (tag.type) {
            case 'email':
                window.open('mailto:' + tag.content, '_blank');
                break;
            case 'phone':
                window.open('tel:' + tag.content, '_blank');
                break;
            case 'url':
                window.open(tag.content, '_blank');
                break;
            case 'none':
                break;
        }
    }

    toggleSelectVisibility(event: MouseEvent) {
        this.isSelectVisible = !this.isSelectVisible;
    }
    moveForSeconds(sec: number): void {
        if (this.player) {
            this.player.nativeElement.currentTime += sec;
        }
    }

    onLoadedMetadata($event: Event): void {
        this.$element.nativeElement.currentTime = this.data.startTime;
    }

   /*  switchFullScreen(): void {
       if (this.player && this.player.nativeElement) {
            this.player.nativeElement.requestFullscreen();
        }
    } */
    
    openFullscreen(): void {
        if(this.isIOSDevice()){
            const video = document.getElementById('video-element');
            // @ts-ignore
            if (video && typeof video?.webkitEnterFullscreen === 'function') {
                // @ts-ignore
                video?.webkitEnterFullscreen();
            }
        }else{
            document.getElementById('all-elements').requestFullscreen();
        }
    }

    closeFullscreen(): void {
        document.exitFullscreen();
    }
    
    /* This is the regular action to mute and unmute*/
    muteVideo(): void {
        this.player.nativeElement.volume = 0;
        this.player.nativeElement.muted = true;
    }
    umuteVideo(): void {
        this.player.nativeElement.volume = 1;
        this.player.nativeElement.muted = false;
    }

    setVolume($event: MouseEvent): void {
        const volumeBar = event.currentTarget as HTMLDivElement;
        const rect = volumeBar.getBoundingClientRect();

        if (event instanceof MouseEvent) {
            const mouseEvent = event as MouseEvent;
            const volumeHeight = rect.height - (mouseEvent.clientY - rect.top);
            const volume = volumeHeight / rect.height;

            if (volume >= 0 && volume <= 1) {
                console.log(volume)
                this.player.nativeElement.volume = volume;
            }
        }
    }

    /**
     * Toggle play/pause pressioning space bar
     */
    playPauseKeyboard(): void {
      const enabledWithControls = this.data.controls && this.videoData.enablePlayButton
      const enabledWithoutControls = !this.data.controls && (this.data.allowPause || !this.data.autoplay)
      if (enabledWithControls || enabledWithoutControls) {
        if (this.player.nativeElement.paused) {
          this.player.nativeElement.play()
        } else {
          this.player.nativeElement.pause()
        }
      } else {
        console.log('play/pause disabled')
      }
    }

    get logoLink() {

      const browserLangCode = navigator.language.split('-')[0].toUpperCase()
      const linksMapping = {
        EN: "https://builderall.com/start-for-free?utm_source=videohosting&utm_medium=video&utm_campaign=poweredby",
        PT: "https://br.builderall.com/start-for-free?utm_source=videohosting&utm_medium=video&utm_campaign=poweredby",
        ES: "https://es.builderall.com/start-for-free?utm_source=videohosting&utm_medium=video&utm_campaign=poweredby",
        IT: "https://it.builderall.com/start-for-free?utm_source=videohosting&utm_medium=video&utm_campaign=poweredby",
        FR: "https://fr.builderall.com/start-for-free?utm_source=videohosting&utm_medium=video&utm_campaign=poweredby",
        DE: "https://builderall.de/start-for-free?utm_source=videohosting&utm_medium=video&utm_campaign=poweredby"
      }

        const baseUrl = linksMapping[browserLangCode] || linksMapping['EN'];
        return baseUrl + (this.videoData.officeUserId ? '#aid='+this.videoData.officeUserId : '');
    }

    onMouseMove(): void {
        clearTimeout(this.moveInterval);
        this.showPlayerControls = true;
        this.moveInterval = setTimeout(() => {
            this.showPlayerControls = false;
            this.isSelectVisible = false;
        }, 3000);
    }

    setProgress($event: MouseEvent): void {
        if (this.player) {
            this.player.nativeElement.currentTime = (($event.clientX - ($event.currentTarget as HTMLDivElement).offsetLeft) / ($event.currentTarget as HTMLDivElement).offsetWidth) * this.player.nativeElement.duration;
        }
    }

}

